<template>
  <transition name="fade-from-top">
    <div class="modal-mask" @mousedown="close" v-if="show">
      <div class="modal" @mousedown.stop>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: ["show"],
  mounted() {
    document.addEventListener("keydown", e => {
      if (this.show && e.keyCode == 27) {
        this.close();
      }
    });
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.fade-from-top-enter-active,
.fade-from-top-leave-active {
  transition: all 0.15s;
}
.fade-from-top-enter,
.fade-from-top-leave-to {
  opacity: 0;
  transform: scale(1.02) translateY(-15px);
}
</style>
